import { Component, Input } from '@angular/core';

@Component({
  selector: 'apc-extra-fields-link-form',
  templateUrl: './link.component.html',
  styleUrls: ['./link.component.scss']
})
export class LinkComponent {
  @Input() public form: any;
  @Input() public typesDropdown: any;
  toggleAlert() {
    this.form.controls['dateEnd'].setErrors(null);
  }

  findDropdownRenderValue() {
    if(this.typesDropdown != typeof undefined){
      let findObject = this.typesDropdown.find(el => el.identifier == this.form.value.extraTypeIdentifier);
      return findObject ? findObject.name : '';
    }
    return '';
  }
}
